import { render, staticRenderFns } from "./FormSubmitButton.vue?vue&type=template&id=16d4d23a&"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports